import type { Content, GroupField } from '@prismicio/client';
import type { Simplify } from '../../../../../prismicio-types';
import { BulletIcons } from '@/assets/index';
import styles from './heroList.module.scss';
import { consistentAnimationDuration } from '@/utils';

interface HeroListProps {
  list: GroupField<
    Simplify<
      | Content.HeroSliceDefaultPrimaryAdvantagesItem
      | Content.HeroSliceOurClientsPrimaryAdvantagesItem
    >
  >;
  isVisible?: boolean;
}

export const HeroList = ({ list, isVisible }: HeroListProps) => {
  return (
    <ul className={styles.list}>
      {list.map((item, index) => (
        <li
          className={`${styles.item} ${isVisible ? styles.isVisible : ''} `}
          style={consistentAnimationDuration(1.1, index)}
          key={item.text}
        >
          <BulletIcons icon={item.icon} />
          <span>{item.text}</span>
        </li>
      ))}
    </ul>
  );
};
